import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
import { Box, CustomModalLayout, Divider, ModalMobileLayout } from '@wix/design-system';
import { Scopes } from './subComponents/Scopes';
import { Header } from './subComponents/Header';
import { TermsAndConditions } from './subComponents/TermsAndConditions';
import { BlocksWithoutEnforcedPermissions } from './subComponents/BlocksWithoutEnforcedPermissions';
import { getAppImageUrl } from '../../selectors/marketListing';
import { Modals } from '../../types';
import { reportModalShown } from '../../bi/bi';
import { ExternalLinkSmall } from '@wix/wix-ui-icons-common';
import { useInstallerContext } from '../../context/InstallerContext';
import { useLibraryTranslations } from '../../context/TranslationsContext';
import css from './UserConsent.scss';
import { ConsentButtons } from './subComponents/ConsentButtons';
import { useConsentModalOnClicks } from './hooks/useConsentModalOnClicks';
import { MarketingUserConsent } from './subComponents/MarketingUserConsent';
import { useRenderControl } from '../../context/InstallerRenderControlContext';
import { useModalsAndWindow } from '../../context/ModalsAndWindowContext';
export const UserConsent = () => {
  const {
    modals: {
      userConsent: {
        modalProps
      }
    }
  } = useModalsAndWindow();
  const {
    preInstallationData: {
      hasBlocksWithoutEnforcedPermissions,
      app,
      consentPermissions
    },
    MarketingConsentContent
  } = useInstallerContext();
  const {
    setInstallerUiReady
  } = useRenderControl();
  const {
    t
  } = useLibraryTranslations();
  const {
    onAgreeButtonClick,
    onCloseButtonClick
  } = useConsentModalOnClicks();
  const {
    shouldOpenNewWindow
  } = modalProps;
  useEffect(() => {
    !MarketingConsentContent && setInstallerUiReady();
    reportModalShown(Modals.userConsent);
  }, []);
  if (hasBlocksWithoutEnforcedPermissions) {
    return /*#__PURE__*/React.createElement(BlocksWithoutEnforcedPermissions, {
      shouldOpenNewWindow: shouldOpenNewWindow,
      onAgreeButtonClick: onAgreeButtonClick,
      onCloseButtonClick: onCloseButtonClick
    });
  }
  if (MarketingConsentContent) {
    return /*#__PURE__*/React.createElement(MarketingUserConsent, {
      onAgreeButtonClick: onAgreeButtonClick,
      onCloseButtonClick: onCloseButtonClick,
      shouldOpenNewWindow: shouldOpenNewWindow
    });
  }
  return /*#__PURE__*/React.createElement(GeneralUserConsentLayout, {
    shouldOpenNewWindow: shouldOpenNewWindow,
    titleText: t('user-consent.agree-and-add.title', {
      appName: app == null ? void 0 : app.name
    }),
    onAgreeButtonClick: onAgreeButtonClick,
    onCloseButtonClick: onCloseButtonClick
  }, /*#__PURE__*/React.createElement("div", {
    className: css.modalContentWrapper
  }, /*#__PURE__*/React.createElement(Scopes, {
    consentPermissions: consentPermissions
  }), /*#__PURE__*/React.createElement(Box, {
    marginTop: "18px",
    paddingTop: "6px"
  }, /*#__PURE__*/React.createElement(TermsAndConditions, null))));
};
export const GeneralUserConsentLayout = _ref => {
  let {
    children,
    shouldOpenNewWindow,
    titleText,
    onAgreeButtonClick,
    onCloseButtonClick,
    ...props
  } = _ref;
  const {
    isMobile,
    preInstallationData: {
      marketListing
    }
  } = useInstallerContext();
  const appImageUrl = getAppImageUrl(marketListing);
  const title = titleText ? /*#__PURE__*/React.createElement(Header, {
    appImageUrl: appImageUrl,
    titleText: titleText
  }) : undefined;
  const {
    t
  } = useLibraryTranslations();
  if (isMobile) {
    return /*#__PURE__*/React.createElement(ModalMobileLayout, _extends({
      title: title,
      onCloseButtonClick: onCloseButtonClick,
      dataHook: "user-consent-mobile-modal-layout",
      content: children,
      footer: /*#__PURE__*/React.createElement(Box, {
        direction: "vertical",
        gap: 1
      }, /*#__PURE__*/React.createElement(ConsentButtons, {
        onAgreeButtonClick: onAgreeButtonClick,
        onCloseButtonClick: onCloseButtonClick,
        shouldOpenInstallerInNewTab: shouldOpenNewWindow,
        dataHook: "mobile"
      }), props.footnote ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), props.footnote) : null)
    }, props));
  }
  return /*#__PURE__*/React.createElement(CustomModalLayout, _extends({
    title: title,
    onCloseButtonClick: onCloseButtonClick,
    showFooterDivider: true,
    width: "600px",
    className: css.modalLayout,
    dataHook: "user-consent-modal-layout",
    primaryButtonText: t('user-consent.agree-and-add.primary-cta'),
    secondaryButtonText: t('user-consent.agree-and-add.secondary-cta'),
    primaryButtonOnClick: onAgreeButtonClick,
    primaryButtonProps: shouldOpenNewWindow ? {
      suffixIcon: /*#__PURE__*/React.createElement(ExternalLinkSmall, null)
    } : {},
    secondaryButtonOnClick: onCloseButtonClick
  }, props), children);
};
//# sourceMappingURL=UserConsent.js.map